import React from 'react';

const RecentVisitors = (props) => {
    return (
        <div id="recent-visitors">
            {/*<div className="card">
                <div className="title">A voir ensemble</div>
                <div className="klingon-banner">
                    ADS
                </div>
            </div>*/}
        </div>
    )
};
export default RecentVisitors;
